import { useAccessTokenStore } from '../../stores/useAccessTokenStore';
import { AuthAPI } from '../../apis/Auth';
import { useEffect, useState } from 'react';

export default function useEdgeAuthService() {
  const state = useAccessTokenStore((state) => state.secret);
  const getAccessToken = useAccessTokenStore((state) => state.getAccessToken);
  const setAccessToken = useAccessTokenStore((state) => state.setAccessToken);
  const removeAccessToken = useAccessTokenStore((state) => state.removeAccessToken);
  const [isAuthenticatedState, setIsAuthenticatedState] = useState<boolean | null>(null); // Null for "undetermined"

  useEffect(() => {
    const accessToken = getAccessToken();
    const authed =
      !!accessToken &&
      !!accessToken.accessToken &&
      !!accessToken.expires &&
      accessToken.expires > new Date();
    setIsAuthenticatedState(authed);

    if (authed) {
      const currentTime = new Date();
      const timeUntilExpiry = accessToken.expires!.getTime() - currentTime.getTime();

      if (timeUntilExpiry <= 0) {
        removeAccessToken();
        console.log('Setting edge authentication to false');
        setIsAuthenticatedState(false);
        return;
      }

      const timer = setTimeout(() => {
        removeAccessToken();
        console.log('Removing due to timeout, setting edge authentication to false');
        setIsAuthenticatedState(false);
      }, timeUntilExpiry);

      return () => clearTimeout(timer);
    }
  }, [state, getAccessToken, removeAccessToken, setAccessToken, setIsAuthenticatedState]);

  const login = async (username: string, password: string) => {
    return AuthAPI.Login({ username, password })
      .then((res) => {
        setAccessToken(res.accessToken);
      })
      .catch((err) => {
        console.warn('login error', err);
      });
  };

  const logout = () => {
    removeAccessToken();
  };

  return {
    getAccessToken,
    isAuthenticated: isAuthenticatedState,
    login,
    logout,
  };
}
